import { render, staticRenderFns } from "./Cabinet.vue?vue&type=template&id=44507774&scoped=true"
import script from "./Cabinet.vue?vue&type=script&lang=js"
export * from "./Cabinet.vue?vue&type=script&lang=js"
import style0 from "./Cabinet.vue?vue&type=style&index=0&id=44507774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44507774",
  null
  
)

export default component.exports